import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'

export const callInitiationValidator = withZod(
  z.object({
    contactId: z.string().min(1, { message: `Contact ID required` }),
    fromNumber: z
      .string()
      .min(10, { message: `From number required` })
      .transform((val) => val.replace(/\D/g, ``))
      .refine((val) => val.length === 10, { message: `Please enter a valid phone number` }),
    toNumber: z
      .string()
      .min(10, { message: `To number required` })
      .transform((val) => val.replace(/\D/g, ``))
      .refine((val) => val.length === 10, { message: `Please enter a valid phone number` }),
    primaryTrackingNumber: z.string().min(1, { message: `This location is missing a primary tracking number` }),
  }),
)
